import { AddExtraDataForm } from '.'
import { ApiService } from '~/shared/api'
import { sendForm } from '~/shared/utils/decorators'
import type { ServiceCanSendForm } from '~/shared/interfaces'

// eslint-disable-next-line
interface EventsService extends ServiceCanSendForm {}

@sendForm
// eslint-disable-next-line no-redeclare
class EventsService extends ApiService {
  protected route: string = 'calendars/events'

  addExtraData(form: AddExtraDataForm) {
    return this.sendForm(form.setSendAs('form-data'), `${this.prefix}/${this.route}/add-extra-data`)
  }
}

export default EventsService
